import { render, staticRenderFns } from "./CreateDistribution.vue?vue&type=template&id=7899b663&"
import script from "./CreateDistribution.vue?vue&type=script&lang=js&"
export * from "./CreateDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports